/// <reference path="../../node_modules/@types/jquery/index.d.ts" />
/// <reference path="../../node_modules/@types/googlemaps/index.d.ts" />

class MarkerWithPopup extends google.maps.Marker
{
    html: string;
}

module DBS.GoogleMap
{
    let xmlPath: string;
    let mapId: string;

    let map: google.maps.Map;
    let infoWindow: google.maps.InfoWindow;
    let initialZoom: boolean;

    let directionsDisplay = new google.maps.DirectionsRenderer();
    let directionsService = new google.maps.DirectionsService();
    let placeMarkers = new Array<google.maps.Marker>();

    function loadXmlDocument(xml: JQueryXHR): void
    {
        const placemarks = (xml.responseXML as XMLDocument).documentElement.getElementsByTagName("Placemark");

        map = new google.maps.Map(document.getElementById(mapId), {
            zoom: 16,
            center: new google.maps.LatLng(0, 0),
            mapTypeId: google.maps.MapTypeId.ROADMAP
        });

        for (let i = 0; i < placemarks.length; i++)
        {
            const placemark = placemarks[i];

            const name = placemarks[i].getElementsByTagName("name")[0].firstChild.nodeValue;
            const desc = placemarks[i].getElementsByTagName("description")[0].childNodes[1].nodeValue;
            const icon = placemarks[i].getElementsByTagName("iconHref")[0].childNodes[1].nodeValue;

            const coords = placemark.getElementsByTagName("coordinates")[0].firstChild.nodeValue.split(",");
            const point = new google.maps.LatLng(parseFloat(coords[1]), parseFloat(coords[0]));

            const marker = new MarkerWithPopup({
                map: map,
                position: point,
                title: name,
                icon: icon
            });
            marker.html = `<h2>${name}</h2>${desc}`;

            google.maps.event.addListener(marker, "click", function()
            {
                if (infoWindow != null)
                {
                    infoWindow.close();
                }

                infoWindow = new google.maps.InfoWindow({
                    content: (this as MarkerWithPopup).html
                });

                infoWindow.open(map, this);
            });

            placeMarkers.push(marker);
        }

        findMapCenterAndZoom();
        setupDirectionsBranchList();
        setupHtmlBranchList();
    }

    function findMapCenterAndZoom(): void
    {
        if (map == null)
        {
            return;
        }

        const bounds = new google.maps.LatLngBounds();
        placeMarkers.forEach((value: google.maps.Marker) =>
        {
            bounds.extend(value.getPosition());
        });

        google.maps.event.addListener(map, "zoom_changed", () =>
        {
            const zoomChangeBoundsListener = google.maps.event.addListener(map, "bounds_changed", function()
            {
                if (this.getZoom() > 12 && initialZoom)
                {
                    // Change max/min zoom here
                    this.setZoom(12);
                    initialZoom = false;
                }
                google.maps.event.removeListener(zoomChangeBoundsListener);
            });
        });

        initialZoom = true;
        map.fitBounds(bounds);
    }

    function setupDirectionsBranchList(): void
    {
        if (placeMarkers.length === 1)
        {
            const half = $("#google-map-to").parent();
            $("#google-map-from").appendTo(half);
            $("#google-map-to").hide();
            $("label[for=google-map-to]").hide();
        }

        for (let i = 0; i < placeMarkers.length; i++)
        {
            $("<option />")
                .attr("value", i)
                .text(placeMarkers[i].getTitle())
                .appendTo("select#google-map-to");
        }
    }

    function setupHtmlBranchList(): void
    {
        const element = document.getElementById(`${mapId}-branch-list`) as HTMLDivElement;
        if (element == null)
        {
            return;
        }

        const branchList = document.createElement("ul") as HTMLUListElement;

        for (let i = 0; i < placeMarkers.length; i++)
        {
            const icon = placeMarkers[i].getIcon();
            if (icon.toString().indexOf("spotlight-waypoint-a.png") > -1)
            {
                continue;
            }

            const link = document.createElement("a") as HTMLAnchorElement;
            link.href = "#";
            link.addEventListener("click", (ev: Event) => (ev.preventDefault(), triggerMarkerClick(i)));
            link.innerText = placeMarkers[i].getTitle();

            const listItem = document.createElement("li") as HTMLLIElement;
            listItem.appendChild(link);

            branchList.appendChild(listItem);
        }

        element.appendChild(branchList);
    }

    function fetchDirections(ev: MouseEvent): void
    {
        ev.preventDefault();

        const fromAddress = (document.getElementById(`${mapId}-from`) as HTMLInputElement).value;
        const destinationObj = (placeMarkers.length === 1
                                    ? placeMarkers[0]
                                    : placeMarkers[(document.getElementById(`${mapId}-to`) as HTMLSelectElement).value]) as google.maps.Marker;

        directionsDisplay.setMap(map);
        directionsDisplay.setPanel(document.getElementById(`${mapId}-directions`));

        directionsService.route({
            origin: fromAddress,
            destination: destinationObj.getPosition(),
            travelMode: google.maps.TravelMode.DRIVING,
            unitSystem: google.maps.UnitSystem.IMPERIAL,
            provideRouteAlternatives: true
        }, presentDirections);
    }

    function presentDirections(result: google.maps.DirectionsResult, status: google.maps.DirectionsStatus): void
    {
        const directions = document.getElementById(`${mapId}-directions`) as HTMLDivElement;
        const errorMsg = document.getElementById(`${mapId}-error`) as HTMLDivElement;

        if (status === google.maps.DirectionsStatus.OK)
        {
            directions.style.display = "block";
            errorMsg.style.display = "none";
            directionsDisplay.setDirections(result);
        }
        else
        {
            directions.style.display = "none";
            errorMsg.style.display = "block";
        }
    }

    function triggerMarkerClick(i: number): void {
        google.maps.event.trigger(placeMarkers[i], "click");
        $(window).scrollTop($(`#${mapId}`).offset().top);
    }

    export function Initialize(XmlPath: string, MapId: string): void
    {
        xmlPath = XmlPath;
        mapId = MapId;

        $.ajax({
            url: xmlPath,
            complete: loadXmlDocument
        });

        const submitBtn = document.getElementById(`${mapId}-submit`);
        submitBtn.addEventListener("click", fetchDirections);
    }
}